import * as React from "react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

type Props = { task: TaskModel };

export const ActiveTaskAction: React.FunctionComponent<Props> = (props) => {
    if (props.task.completed || props.task.cancelled) {
        return null;
    }

    return <>{props.children}</>;
};
